// The day as spoken commands see it: the running task, else the first of
// Today, as the one "start" and "done" act on, and the rest after it.
import { useResource, useSettings, useTasks } from '@/db/hooks'
import type { TaskResource } from '@/kinds/task/apply'
import type { TaskSpec, TaskStatus } from '@/kinds/task/schema'
import { selectToday } from '@/lib/today'
import { todayLocal } from '@/lib/time'
import { useUi } from '@/state/ui'

export const useVoiceToday = () => {
  const tasks = useTasks() ?? []
  const settings = useSettings()
  const picker = useUi((s) => s.picker)
  const activeId = useUi((s) => s.activeTaskId)
  const active = useResource<TaskSpec, TaskStatus>(activeId ?? undefined) as TaskResource | undefined
  const running = active && active.status.started_at && !active.deleted_at ? active : undefined
  const sel = selectToday(tasks, { today: todayLocal(), cap: settings.today_cap, picker })
  const hero = running ?? sel.all[0]
  const rest = sel.all.filter((t) => t.id !== hero?.id)
  return { hero, rest, running }
}
